import React from "react";
import "../src/assets/components/global.css";
import logo from "../src/assets/components/images/Lanao_del_Norte_Seal.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faSkype,
  faTiktok,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <div id="footer-page">
      <div className="social-media-icons">
        <a
          href="https://www.facebook.com"
          target="_blank"
          rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFacebook} size="2x" />
        </a>
        <a
          href="https://www.twitter.com"
          target="_blank"
          rel="noopener noreferrer">
          <FontAwesomeIcon icon={faTwitter} size="2x" />
        </a>
        <a
          href="https://www.skype.com"
          target="_blank"
          rel="noopener noreferrer">
          <FontAwesomeIcon icon={faSkype} size="2x" />
        </a>
        <a
          href="https://www.tiktok.com"
          target="_blank"
          rel="noopener noreferrer">
          <FontAwesomeIcon icon={faTiktok} size="2x" />
        </a>
        <a
          href="https://www.instagram.com"
          target="_blank"
          rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} size="2x" />
        </a>
      </div>
      <div className="wrap">
        <div id="footer-container">
          <div className="footer footer-one">
            <img
              src={logo}
              alt="Lanao del Norte Seal"
              title="Lanao del Norte Seal"
              width="150px"
              height="150px"
            />
            <p>
              &copy; 2024 Barangay Gumagamot. <br></br>All rights reserved.
            </p>
          </div>
          <div className="footer footer-two">
            <h5>Information</h5>
            <p>
              <a href="brgyofficials">Brgy Officials</a>
            </p>
            <p>
              <a href="members">Members</a>
            </p>
            <p>
              <a href="communityfeatures">Community Features</a>
            </p>
            <p>
              <a href="systemInfo">System Information</a>
            </p>
          </div>
          <div className="footer footer-three">
            <h5>Contact Us</h5>
            <p>
              <label>Email:</label>
              <a href="mailto:contact@barangaygumagamot.ph">
                contact@barangaygumagamot.ph
              </a>
            </p>
            <p>
              <label>Phone:</label>+63 912 345 6789
            </p>
            <p>
              <label>Address:</label>
              <a href="Barangay Gumagamot Lala LDN Philippines">
                Barangay Gumagamot,<br></br> Lala, LDN, Philippines
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
